module.exports = __webpack_public_path__ + "img/CAL-IEC-S.bde0b4b7.webp";